// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"de8000b1","66":"acc62860","287":"fc46c3d4","428":"77554f4b","557":"81de5fcf","576":"0bad454d","801":"514cf6c8"}[chunkId] + ".chunk.js";
};